import { FilterTypes, OptionsSortType } from 'Core/interfaces'

import { UrlParams, UrlParamsLabel } from 'Portals/Customer/constants'
import {
	Wastestream,
	WastestreamFilterFields,
	WastestreamSearchResultFields
} from 'Portals/Customer/entities'

export const searchConfig: Wastestream.Search.Config = {
	[WastestreamSearchResultFields.wastestreamId]: {
		label: 'Wastestream ID',
		apiFieldName: WastestreamSearchResultFields.wastestreamId,
		apiSearchFieldName: 'WastestreamId',
		filterType: FilterTypes.ID,
		UrlParam: UrlParams.id,
		UrlParamLabel: UrlParamsLabel.manifestIdLabel,
		isLabelAndId: true,
		optionsSortType: OptionsSortType.byId
	},
	[WastestreamSearchResultFields.wastestreamName]: {
		label: 'Wastestream Name',
		apiFieldName: WastestreamSearchResultFields.wastestreamName,
		apiSearchFieldName: 'WastestreamId',
		filterType: FilterTypes.ID,
		UrlParam: UrlParams.name,
		UrlParamLabel: UrlParamsLabel.manifestNameLabel,
		isLabelAndId: true,
		optionsSortType: OptionsSortType.byId
	}
}

export const filtersConfig: Wastestream.Filter.Config = {
	[WastestreamFilterFields.serviceSite]: {
		label: 'Service Site:',
		apiFilterFieldName: WastestreamFilterFields.serviceSite,
		filterType: FilterTypes.ID,
		UrlParam: UrlParams.serviceSiteId,
		defaultValue: ''
	}
}
